module.exports = __webpack_public_path__ + "img/weChat_supplier_active.4a58dcb3.png";